'use strict';
/**
 * Internal dependencies;
 */

var isShallowEqualObjects = require('./objects');

var isShallowEqualArrays = require('./arrays');

var isArray = Array.isArray;
/**
 * Returns true if the two arrays or objects are shallow equal, or false
 * otherwise.
 *
 * @param {(Array|Object)} a First object or array to compare.
 * @param {(Array|Object)} b Second object or array to compare.
 *
 * @return {boolean} Whether the two values are shallow equal.
 */

function isShallowEqual(a, b) {
  if (a && b) {
    if (a.constructor === Object && b.constructor === Object) {
      return isShallowEqualObjects(a, b);
    } else if (isArray(a) && isArray(b)) {
      return isShallowEqualArrays(a, b);
    }
  }

  return a === b;
}

module.exports = isShallowEqual;
module.exports.isShallowEqualObjects = isShallowEqualObjects;
module.exports.isShallowEqualArrays = isShallowEqualArrays;